import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HashRouter> {/* 🔥 SIN basename */}
      <App />
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();